module.exports = __webpack_public_path__ + "media/images/chat-delete-active-dbb43929.svg";